export default __webpack_public_path__ + "static/media/balsamandlake.1c3d7e7a.jpg";